/* ============================================================
   GOOTER — Policy Page Enhancement
   ============================================================
   Reicht Shopify's fest gerenderte Policy-Page um folgende
   Features an:
   - "Letzte Aktualisierung"-Badge (auto-detektiert oder via Meta)
   - Stable IDs auf h2/h3 + Anchor-Links per Hover
   - Sticky Inhaltsverzeichnis (Desktop)
   - Active-Section-Highlight via IntersectionObserver
   - Smooth-Scroll für Anker-Klicks
   - Kontakt-CTA am Seitenende

   Konfiguration kann über data-* Attribute am <html>-Tag oder
   per window.GOOTER_POLICY_CONFIG = {...} überschrieben werden.
   Defaults: TOC=true, Contact=true, Updated="Letzte Fassung..."
   ============================================================ */

(function () {
  'use strict';

  var container = document.querySelector('.shopify-policy__container');
  if (!container) return;

  /* ---- Locale detection (DE primary, EN secondary) ----
     Read from <html lang>, then fall back to URL pathname prefix /en/. */
  var LOC = (document.documentElement.lang || 'de').slice(0,2).toLowerCase();
  if (LOC !== 'en') {
    try {
      var _pn = (window.location && window.location.pathname) || '';
      var _m = _pn.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(\/|$)/i);
      if (_m && _m[1].slice(0,2).toLowerCase() === 'en') LOC = 'en';
    } catch (_e) {}
  }
  var IS_EN = LOC === 'en';

  var I18N = IS_EN ? {
    updatedLabel: 'Last updated: ',
    updatedRegex: /^(last\s+(updated|revision|change|version)\s*:?\s*)(.+)/i,
    sectionSlug: 'section',
    anchorAria: 'Direct link to this section',
    tocAria: 'Table of contents',
    tocLabel: 'Contents',
    ctaTitle: 'Questions or concerns?',
    ctaText: 'Write to us directly &mdash; we respond personally.'
  } : {
    updatedLabel: 'Letzte Aktualisierung: ',
    updatedRegex: /^(letzte\s+(fassung|aktualisierung|änderung)\s*:?\s*)(.+)/i,
    sectionSlug: 'abschnitt',
    anchorAria: 'Direkter Link zu diesem Abschnitt',
    tocAria: 'Inhaltsverzeichnis',
    tocLabel: 'Inhalt',
    ctaTitle: 'Fragen oder Anliegen?',
    ctaText: 'Schreib uns direkt &mdash; wir antworten persönlich.'
  };

  var config = window.GOOTER_POLICY_CONFIG || {};
  var enableTOC = config.toc !== false;
  var enableContact = config.contact !== false;
  var contactEmail = config.email || 'support@gooter-golf.com';
  var contactPhone = config.phone || '+43 800 7000 477';

  var title = container.querySelector('.shopify-policy__title');
  var body = container.querySelector('.shopify-policy__body');
  var rte = body ? body.querySelector('.rte') : null;
  if (!rte) return;

  /* --- 1) "Letzte Aktualisierung"-Badge ------------------------ */
  /* Extrahiert das Datum aus dem 1. Paragraph wenn er mit
     "Letzte Fassung:" oder ähnlich startet. */

  var firstP = rte.querySelector('div > p, p');
  var updatedText = null;
  var updatedSrcP = null;
  if (firstP) {
    var pText = (firstP.textContent || '').trim();
    /* Try both locales so the badge works regardless of which locale's
       source content is rendered (Shopify auto-translates the body, but
       the leading paragraph may still match either pattern). */
    var match = pText.match(I18N.updatedRegex)
             || pText.match(/^(letzte\s+(fassung|aktualisierung|änderung)\s*:?\s*)(.+)/i)
             || pText.match(/^(last\s+(updated|revision|change|version)\s*:?\s*)(.+)/i);
    if (match) {
      updatedText = match[3].trim().replace(/\.$/, '');
      updatedSrcP = firstP; /* 06.10.2026: wird unten an gleicher Stelle durch das Badge ersetzt (kein Layoutsprung) */
    }
  }
  if (!updatedText && config.updatedDate) {
    updatedText = config.updatedDate;
  }

  if (updatedText && title) {
    var badge = document.createElement('p');
    badge.className = 'policy-updated';
    badge.innerHTML = '<span class="policy-updated__dot" aria-hidden="true"></span>'
      + I18N.updatedLabel + '<time>' + escapeHtml(updatedText) + '</time>';
    if (updatedSrcP && updatedSrcP.parentNode) {
      updatedSrcP.parentNode.replaceChild(badge, updatedSrcP);
    } else {
      title.insertBefore(badge, title.firstChild);
    }
  }

  /* --- 2) Stable IDs + Anchor-Links für h2/h3 ------------------ */

  var slugify = function (text) {
    return (text || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[ä]/g, 'ae')
      .replace(/[ö]/g, 'oe')
      .replace(/[ü]/g, 'ue')
      .replace(/[ß]/g, 'ss')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  };

  var seen = {};
  var headings = rte.querySelectorAll('h2, h3');
  var h2List = [];

  headings.forEach(function (h) {
    var raw = (h.textContent || '').replace(/#$/, '').trim();
    var base = slugify(raw) || I18N.sectionSlug;
    var id = base;
    var i = 2;
    while (seen[id]) { id = base + '-' + i; i++; }
    seen[id] = true;
    h.id = id;

    var anchor = document.createElement('a');
    anchor.href = '#' + id;
    anchor.className = 'policy-anchor';
    anchor.setAttribute('aria-label', I18N.anchorAria);
    anchor.innerHTML = '<span aria-hidden="true">#</span>';
    h.appendChild(anchor);

    if (h.tagName === 'H2') {
      h2List.push({ id: id, text: raw });
    }
  });

  /* --- 3) Table of Contents (Desktop sticky) ------------------- */

  /* 06.10.2026: Layout reserviert die TOC-Spalte schon vor dem Einfuegen (kein Layoutsprung); ohne TOC zurueck auf 1 Spalte */
  /* Gleiche Bedingung wie das CSS in gooter-tokens.css (:has(.rte h2 ~ h2 ~ h2)); ohne :has-Unterstuetzung kein TOC */
  var tocLayout = false;
  try { tocLayout = container.matches(':has(.rte h2 ~ h2 ~ h2)'); } catch (_e) { tocLayout = false; }
  var showTOC = enableTOC && h2List.length >= 3 && tocLayout;
  if (!showTOC) {
    container.classList.add('no-policy-toc');
  }

  if (showTOC) {
    container.classList.add('has-policy-toc');

    var toc = document.createElement('aside');
    toc.className = 'policy-toc';
    toc.setAttribute('aria-label', I18N.tocAria);

    var inner = document.createElement('div');
    inner.className = 'policy-toc__inner';

    var label = document.createElement('p');
    label.className = 'policy-toc__label';
    label.textContent = I18N.tocLabel;
    inner.appendChild(label);

    var ul = document.createElement('ul');
    ul.className = 'policy-toc__list';

    h2List.forEach(function (h) {
      var li = document.createElement('li');
      li.className = 'policy-toc__item';
      var a = document.createElement('a');
      a.className = 'policy-toc__link';
      a.href = '#' + h.id;
      a.setAttribute('data-toc-link', h.id);
      a.textContent = h.text;
      li.appendChild(a);
      ul.appendChild(li);
    });

    inner.appendChild(ul);
    toc.appendChild(inner);

    body.insertBefore(toc, body.firstChild);

    /* Active highlight */
    if ('IntersectionObserver' in window) {
      var tocLinks = toc.querySelectorAll('[data-toc-link]');
      var linkById = {};
      tocLinks.forEach(function (l) {
        linkById[l.getAttribute('data-toc-link')] = l;
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var l = linkById[entry.target.id];
          if (!l) return;
          if (entry.isIntersecting) {
            tocLinks.forEach(function (x) { x.classList.remove('is-active'); });
            l.classList.add('is-active');
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px' });

      rte.querySelectorAll('h2').forEach(function (h) { observer.observe(h); });
    }
  }

  /* --- 4) Smooth-Scroll für alle Anker-Links ------------------- */

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.policy-toc__link, .policy-anchor');
    if (!link) return;
    var hash = link.getAttribute('href');
    if (!hash || hash.charAt(0) !== '#') return;
    var target = document.getElementById(hash.slice(1));
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
    if (history.pushState) history.pushState(null, '', hash);
  });

  /* --- 5) Contact-CTA am Seitenende ---------------------------- */

  if (enableContact) {
    var cta = document.createElement('aside');
    cta.className = 'policy-contact';
    cta.innerHTML =
      '<div class="policy-contact__inner">'
      + '<h2 class="policy-contact__title">' + I18N.ctaTitle + '</h2>'
      + '<p class="policy-contact__text">' + I18N.ctaText + '</p>'
      + '<div class="policy-contact__actions">'
      +   '<a class="policy-contact__btn policy-contact__btn--primary" href="mailto:'
      +     escapeAttr(contactEmail) + '">' + escapeHtml(contactEmail) + '</a>'
      +   '<a class="policy-contact__btn policy-contact__btn--secondary" href="tel:'
      +     escapeAttr(contactPhone.replace(/\s/g, '')) + '">' + escapeHtml(contactPhone) + '</a>'
      + '</div>'
      + '</div>';
    container.appendChild(cta);
  }

  /* --- helpers ------------------------------------------------- */

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function escapeAttr(s) {
    return escapeHtml(s);
  }
})();
